module.exports = __webpack_public_path__ + "img/logo_RB-color.d9af25a1.svg";